import { render, staticRenderFns } from "./InfoHelpGrid.vue?vue&type=template&id=0c0579a9&scoped=true"
import script from "./InfoHelpGrid.vue?vue&type=script&lang=js"
export * from "./InfoHelpGrid.vue?vue&type=script&lang=js"
import style0 from "./InfoHelpGrid.vue?vue&type=style&index=0&id=0c0579a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0579a9",
  null
  
)

export default component.exports